export const LOGIN_TYPE_KEY = 'loginType';
export const AUTH_TOKEN_KEY = 'token';

export const PODE_ACAO_DEMANDA_KEY = 'podeAcaoDemanda';

export const TIPO_REPRESENTACAO_GOVBR_KEY = 'tipoRepresentacaoSelecionadaUserGovbr';
export const ID_REPRESENTACAO_KEY = 'idRepresentacao';
export const ID_TIPO_REPRESENTACAO_GOVBR_KEY = 'idTipoRepresentacaoSelecionadoGovbr';

export const MAP_ZOOM_KEY = 'mapZoom';
export const MAP_CENTER_KEY = 'mapCenter';
export const HEATMAP_ZOOM_KEY = 'heatmapZoom';
export const HEATMAP_CENTER_KEY = 'heatmapCenter';

export const ACTIVE_PAGE_KEY = 'activePage';

export const CONCESSIONARIAS_EMAIL_KEY = 'concessionariasEmail';
export const CONCESSIONARIAS_EMAIL_SENT_KEY = 'concessionariasEmailSent';
